<app-modal
  #modal
  [modalConfig]="{
    titleText: 'Edit Level Descriptions',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    customFooter: true,
    closeOnBgClick: true,
    options: {
      size: 'lg',
    },
  }"
  (isDismissing)="closeModal()">
  <button
    [disabled]="isUpdating"
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="closeModal()">
    <i class="bi bi-x-lg text-white"></i>
  </button>

  <div *ngIf="isUpdating">
    <div class="w-100 is-updating-container">
      <app-loader [text]="'Updating'"></app-loader>
    </div>
  </div>
  <ng-container *ngIf="!isUpdating && competencyGis && gisForm && modal.isOpen">
    <form [formGroup]="gisForm">
      <div class="fw-600 fs-16 mb-2">
        {{ competencyTitle }}
      </div>
      <div class="levels-wrapper">
        <div class="level-item">
          <div class="level-header">
            <label for="level1" class="XXform-label level-name">{{
              levelNames[0]
            }}</label>
          </div>
          <div class="level-content">
            <textarea
              formControlName="level1"
              placeholder="Enter content"
              class="form-control title-input"
              name="description"
              aria-label="Description"
              rows="7"
              [ngClass]="{
                'is-invalid': gisFormSubmitted && f['level1'].errors
              }"></textarea>
          </div>
        </div>
        <div class="level-item">
          <div class="level-header">
            <label for="level2" class="XXform-label level-name">{{
              levelNames[1]
            }}</label>
          </div>
          <div class="level-content">
            <textarea
              formControlName="level2"
              placeholder="Enter content"
              class="form-control title-input"
              name="description"
              aria-label="Description"
              rows="7"
              [ngClass]="{
                'is-invalid': gisFormSubmitted && f['level2'].errors
              }"></textarea>
          </div>
        </div>
        <div class="level-item" *ngIf="competencyGis.length >= 3">
          <div class="level-header">
            <label for="level3" class="XXform-label level-name">{{
              levelNames[2]
            }}</label>
          </div>
          <div class="level-content">
            <textarea
              formControlName="level3"
              placeholder="Enter content"
              class="form-control title-input"
              name="description"
              aria-label="Description"
              rows="7"
              [ngClass]="{
                'is-invalid': gisFormSubmitted && f['level3'].errors
              }"></textarea>
          </div>
        </div>
        <div class="level-item" *ngIf="competencyGis.length >= 4">
          <div class="level-header">
            <label for="level4" class="XXform-label level-name">{{
              levelNames[3]
            }}</label>
          </div>
          <div class="level-content">
            <textarea
              formControlName="level4"
              placeholder="Enter content"
              class="form-control title-input"
              name="description"
              aria-label="Description"
              rows="7"
              [ngClass]="{
                'is-invalid': gisFormSubmitted && f['level4'].errors
              }"></textarea>
          </div>
        </div>
        <div class="level-item" *ngIf="competencyGis.length >= 5">
          <div class="level-header">
            <label for="level5" class="XXform-label level-name">{{
              levelNames[4]
            }}</label>
          </div>
          <div class="level-content">
            <textarea
              formControlName="level5"
              placeholder="Enter content"
              class="form-control title-input"
              name="description"
              aria-label="Description"
              rows="7"
              [ngClass]="{
                'is-invalid': gisFormSubmitted && f['level5'].errors
              }"></textarea>
          </div>
        </div>
      </div>
    </form>
  </ng-container>

  <div footerContent>
    <div class="d-flex justify-content-between align-items-center">
      <button type="button" class="btn" (click)="closeModal()">Cancel</button>
      <button
        [disabled]="isUpdating"
        type="submit"
        class="btn btn-md btn-primary"
        (click)="onSubmit()">
        <ng-container *ngIf="isUpdating">
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </ng-container>
        Update
      </button>
    </div>
  </div>
</app-modal>
